import type { EntityStatus } from '@ms/yammer-data-support';
import { getStatus } from '@ms/yammer-data-support';

import type { StorylineSettings, YammerState } from '../../state/types';

type GetStorylineSettings = (state: YammerState) => StorylineSettings | undefined;
/**
 * @deprecated PERFORMANCE This returns an entire fulfilled settings object and will force re-renders if the settings
 * get updated. This should be replaced by primitive value selectors for individual settings.
 */
export const getStorylineSettings: GetStorylineSettings = (state: YammerState) => state.storylineSettings.fulfilled;

type GetStorylineSettingsStatus = (state: YammerState) => EntityStatus;
export const getStorylineSettingsStatus: GetStorylineSettingsStatus = (state) => getStatus(state.storylineSettings);

type GetIsStorylineMultiTenantOrganizationEnabled = (state: YammerState) => boolean;
export const getIsStorylineMultiTenantOrganizationEnabled: GetIsStorylineMultiTenantOrganizationEnabled = (state) =>
  getStorylineSettings(state)?.isStorylineMultiTenantOrganizationEnabled ?? false;

type CanCreateMediaPost = (state: YammerState) => boolean;
export const canCreateMediaPost: CanCreateMediaPost = (state) => {
  const storylineSettings = getStorylineSettings(state);

  const viewerCanAccessStories = !!storylineSettings?.viewerCanAccessStories;
  const viewerCanAccessStoryline = !!storylineSettings?.viewerCanAccessStoryline;

  return viewerCanAccessStories && viewerCanAccessStoryline;
};
